import { VersionHistoryEntry, versionHistory } from "../lib/versionHistory";

const releaseDateFormatter = new Intl.DateTimeFormat("en-US", {
  month: "long",
  day: "numeric",
  year: "numeric",
  timeZone: "UTC"
});

function deploymentDates(entry: VersionHistoryEntry) {
  if (entry.previewPushedOn) {
    return [
      { label: "Preview pushed", date: entry.previewPushedOn },
      ...(entry.productionPushedOn
        ? [{ label: "Production pushed", date: entry.productionPushedOn }]
        : [])
    ];
  }

  return [{ label: "Pushed", date: entry.pushedOn }];
}

export function VersionHistoryScreen() {
  return (
    <div className="stack-sm">
      <section className="card stack-xs">
        <div className="row-between">
          <div>
            <h2>Version History</h2>
          </div>
        </div>
      </section>

      {versionHistory.map((entry) => (
        <section key={entry.version} className="card stack-sm version-history-card">
          <div className="row-between">
            <h3 className="version-history-title">
              <span className="shift-footer-version">v{entry.version}</span>
            </h3>
            <div className="version-history-meta muted">
              <span className="small">
                {entry.commits.length} {entry.commits.length === 1 ? "commit" : "commits"}
              </span>
              {deploymentDates(entry).map(({ label, date }) => (
                <time key={label} dateTime={date}>
                  {label} {releaseDateFormatter.format(new Date(`${date}T00:00:00Z`))}
                </time>
              ))}
            </div>
          </div>
          <ul className="version-commit-list">
            {entry.commits.map((message) => (
              <li key={message}>{message}</li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
